import React from 'react'
import { Subscribe } from 'unstated'
import Tabs from '../../../../../Components/Tabs/Tabs'
import About from './About'
import LessonPlan from './LessonPlan'
import Timings from './Timings'
import CourseStore from '../../../Store/CourseStore'
import CourseNotes from './CourseNotes'

const tabs = [
  {
    name: 'About the Course',
    Component: About,
    condition: () => true,
  },
  {
    name: 'Lesson Plan',
    Component: LessonPlan,
    condition: () => true,
  },
  {
    name: 'Timings',
    Component: Timings,
    condition: (userType, courseType, isGroupCourse) => {
      return courseType !== 'recorded' && !isGroupCourse
    },
  },
  {
    name: 'Notes',
    Component: CourseNotes,
    condition: (userType) => userType === 'student' || userType === 'teacher',
  },
  // {
  //   name: "Review",
  //   Component: Reviews,
  //   condition: () => true
  // }
]

const Details = ({ restricted, editMode }) => (
  <Subscribe to={[CourseStore]}>
    {({ state: { userType, type, isGroupCourse } }) => (
      <div className='details'>
        <Tabs
          titles={tabs
            .filter((tab) => tab.condition(userType, type, isGroupCourse))
            .map((tab) => tab.name)}
          id={'courseDetailsTab'}
        >
          {(active, updateActive) => {
            const { Component } = tabs.filter((tab) =>
              tab.condition(userType, type, isGroupCourse),
            )[active]
            return (
              <Component
                changeTab={(index) => updateActive(index)}
                editMode={editMode}
                restricted={restricted}
              />
            )
          }}
        </Tabs>
      </div>
    )}
  </Subscribe>
)

export default Details
